import { RepositoryFactory } from '@/api/RepositoryFactory';
import { ActionTree, Module } from 'vuex';
import RevisionRepository from '@/api/RevisionRepository';
import Revision from '@/models/Revision';
import { RevisionState } from '@/store/storeStateInterface';

const revisionRepository: RevisionRepository = RepositoryFactory.get('revision');

const store: RevisionState = {
    allRevisions: []
};

const actions: ActionTree<any, any> = {
    /* Wenn ich bspw. eine Revision anklicke */
    // getRevisionAction: async (_, payload: { revisionId: string }): Promise<Revision> => {
    //     console.log('payload', payload);
    //     const revisionData = await revisionRepository.getRevision(payload.revisionId);
    //     const revision = Revision.parseFromObject(revisionData);
    //     return revision;
    // },
    // eslint-disable-next-line
    createRevisionAction: async ({ commit }, payload: { revision: Partial<Revision>, projectId: string }): Promise<Revision> => {
        const newRevision = Revision.parseFromObject({
            title: payload.revision.title || 'Untitled Revision',
            isLatest: payload.revision.isLatest ?? true,
            project: payload.projectId,
            previousVersion: payload.revision.previousVersion || undefined,
            actuators: payload.revision.actuators || [],
            tag: payload.revision.tag || 'feet',
            comment: payload.revision.comment,
            contactPerson: payload.revision.contactPerson,
            creator: payload.revision.creator
        });
        const revisionData = await revisionRepository.createRevision(newRevision);
        const revision = Revision.parseFromObject(revisionData);
        return revision;
    },

    deleteRevisionAction: async ({ commit }, payload: { revisionId: string }): Promise<Revision> => {
        const revisionData = await revisionRepository.deleteRevision(payload.revisionId);
        const deletedRevision = Revision.parseFromObject(revisionData);
        commit('removeRevision', { revision: deletedRevision });
        return deletedRevision;
    },
    /* for Reloading ProjectView/CustomerDetailView */
    getAllRevisionsActionByProjectId: async ({ commit }, payload: { projectId: string }): Promise<Revision[]> => {
        const revisionData = await revisionRepository.getAllRevisions(payload.projectId);
        const revisions = Revision.parseFromArray(revisionData) as Revision[];
        commit('saveAllRevisions', { revisions });
        return revisions;
    }
};

const mutations = {
    /* for refresing */
    saveAllRevisions: (state: RevisionState, payload: { revisions: Revision[] }) => {
        state.allRevisions = payload.revisions;
    },
    removeRevision: (state: RevisionState, payload: { revision: Revision }) => {
        state.allRevisions = state.allRevisions!.filter(revision => revision.id !== payload.revision.id);
    },
    updateAllRevisions: (state: RevisionState, payload: { revision: Revision }) => {
        const foundIndex = state.allRevisions.findIndex(element => element.id === payload.revision.id);
        state.allRevisions.splice(foundIndex, 1, payload.revision);
    }
};

const getters = {
    allRevisions: (state: RevisionState) => {
        return state.allRevisions;
    }
};

const projectStore: Module<any, any> = {
    namespaced: true,
    state: store,
    actions,
    mutations,
    getters
};

export default projectStore;
